import { render, staticRenderFns } from "./browserVersionReminder.vue?vue&type=template&id=100712d2&"
import script from "./browserVersionReminder.vue?vue&type=script&lang=js&"
export * from "./browserVersionReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports